const formatCsvValue = (value: unknown): string => {
  if (Array.isArray(value)) {
    return value.map(formatCsvValue).join(';');
  }
  if (value === null || value === undefined) {
    return '';
  }
  if (value instanceof Date) {
    return value.toISOString();
  }
  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'bigint'
  ) {
    return String(value);
  }
  const serializedValue = JSON.stringify(value);
  return typeof serializedValue === 'string' ? serializedValue : '';
};

export const exportToCSV = (
  data: Array<Record<string, unknown>>,
  headers: Array<string>,
  filename: string,
) => {
  const csvRows = [];
  // Add headers
  csvRows.push(headers.join(','));

  // Add data rows
  for (const row of data) {
    const values = headers.map((header) => {
      const value = row[header];
      const formattedValue = formatCsvValue(value);
      // Escape quotes and wrap in quotes if contains comma, semicolon, or newline
      return formattedValue.includes(',') ||
        formattedValue.includes(';') ||
        formattedValue.includes('\n')
        ? `"${formattedValue.replace(/"/g, '""')}"`
        : formattedValue;
    });
    csvRows.push(values.join(','));
  }

  // Create blob and download
  const csvString = csvRows.join('\n');
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadCSV = (csvText: string, filename: string) => {
  const blob = new Blob([csvText], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

/**
 * Standard CSV headers for enrolled students export
 */
export const ENROLLED_STUDENTS_CSV_HEADERS = {
  STUDENT_NAME: 'Student Name',
  FAMILY_NAME: 'Family Name',
  GENDER: 'Gender',
  DOB: 'Date of Birth',
  AGE: 'Age',
  COSTUME_SIZE: 'Costume Size',
  ENROLLMENT_DATE: 'Enrollment Date',
} as const;

/**
 * Standard CSV headers for event payment history export
 */
export const EVENT_PAYMENT_CSV_HEADERS = {
  STUDENT_NAME: 'Student Name',
  PAYMENT_STATUS: 'Payment Status',
  ENROLLMENT_STATUS: 'Enrollment Status',
  ENROLLMENT_DATE: 'Enrollment Date',
  DUE_DATE: 'Due Date',
  TOTAL_AMOUNT: 'Total Invoice',
  AMOUNT_PAID: 'Amount Paid',
  PAYMENT_INTENT_ID: 'Payment Intent ID',
  PROBLEM: 'Problem',
} as const;
